<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This work is dedicated to Doctors without Borders (MSF) and the victims of conflicts over natural resources all over the world.</p>
<p>This story may be of value for <a href="http://www.thesentry.org" target="_blank">www.thesentry.org</a>, and their team of policy analysts, regional experts and financial forensics investigators that follows the money in order to create consequences for those funding and profiting from genocide and other mass atrocities in Africa and to build leverage for peace.</p>
<p>I hope that people from the World Economic Forum, United Nations, commodity traders, scientists, business and finance people and any governmental or non-governmental organisation interested in Sustainable Development Goals, and Corporate Social Responsibility, will take some time to read this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?89d88d4c